import { render, staticRenderFns } from "./ImportContacts.vue?vue&type=template&id=55c09730&"
import script from "./ImportContacts.vue?vue&type=script&lang=ts&"
export * from "./ImportContacts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports